module.exports = __webpack_public_path__ + "img/学生.4148f870.png";